import { type StoreActionApi } from 'react-sweet-state';

import type { ChatMessageResearchStore } from './types';

type MarkAnswerPartReceivedArgs = { messageId: string };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const markAnswerPartReceived: (
	args: MarkAnswerPartReceivedArgs,
) => ChatMessageResearchStoreAction =
	({ messageId }: { messageId: string }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const message = getState()[messageId];
		if (message && !message.hasReceivedAnswerPart) {
			setState({
				[messageId]: {
					...message,
					hasReceivedAnswerPart: true,
				},
			});
		}
	};
